module.exports = __webpack_public_path__ + "static/media/external-link.16a1e703.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/external-link.svg
// module id = 901
// module chunks = 0